import { ColorResult, HSLColor, RGBColor } from 'react-color';

export function hexToRgb(hex: string): RGBColor {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        a: 100,
        b: parseInt(result[3], 16),
        g: parseInt(result[2], 16),
        r: parseInt(result[1], 16),
      }
    : { r: 0, g: 0, b: 0, a: 100 };
}

export function rgbToHsl(r: number, g: number, b: number): HSLColor {
  (r /= 255), (g /= 255), (b /= 255);

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = (max + min) / 2;
  let s = (max + min) / 2;
  const l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return { h, s, l };
}

export const rgbToString = (rgb: RGBColor) => {
  return 'rgba(' + [rgb.r, rgb.g, rgb.b, rgb.a].join(',') + ')';
};

export const hexToColorResult = (hex: string): ColorResult => {
  const rgb = hexToRgb(hex);
  return { hex, rgb, hsl: rgbToHsl(rgb.r, rgb.g, rgb.b) };
};
